import React from 'react';
import * as Styles from './FastCheckoutSuccess.styles';
import { Button, IconSuccess } from 'gatorcomponents';
import successImage from '../../media/fastcheckout-success.png';
import successImageES from '../../media/fastcheckout-success-es.png';
import { isBRServer } from '@/utils/Validators/validation';
import { useDispatch } from 'react-redux';
import { fastCheckoutActions } from '@/redux/modules';

const FastCheckoutSuccess = ({ locale, handleFinishSuccessPurchase }) => {
  const dispatch = useDispatch();
  const {
    title, description, ctaLabel,
  } = locale;

  const handleOnFinish = () => {
    handleFinishSuccessPurchase && handleFinishSuccessPurchase();
    dispatch(fastCheckoutActions.reset());
  };

  return (
    <>
      <Styles.Content>
        <Styles.ContentWrapper>
          <Styles.InfoContentWrapper>
            <Styles.IconSuccessWrapper>
              <IconSuccess size="xl" />
            </Styles.IconSuccessWrapper>
            <Styles.SuccessTitle>{title}</Styles.SuccessTitle>
            <Styles.SuccessDescription>{description}</Styles.SuccessDescription>
            <Styles.ButtonWrapper>
              <Button onClick={handleOnFinish} version="v2" width="full" label={ctaLabel} />
            </Styles.ButtonWrapper>
          </Styles.InfoContentWrapper>
        </Styles.ContentWrapper>
        <Styles.ImageWrapper>
          <Styles.SuccessImage src={!isBRServer ? successImage : successImageES} />
        </Styles.ImageWrapper>
      </Styles.Content>
    </>
  );
};

export default FastCheckoutSuccess;
